/**
 * cost-schema.ts — ต้นทุนมาตรฐานราย SKU แบบ effective-dated (CONTEXT §7, T070)
 *
 * กติกา:
 * - ต้นทุนที่มีผล ณ วันที่รับรู้ = row ที่ effective_from ≤ date < effective_to (half-open)
 * - ช่วงห้ามซ้อน (DB exclusion constraint); ต้นทุนใหม่ไม่แก้รายการเก่าย้อนหลัง (snapshot)
 */
import { z } from 'zod';
import { moneyString, uuid, dateKey } from './schemas.js';

export const standardCostInput = z.object({
  skuId: uuid,
  unitCost: moneyString,
  effectiveFrom: dateKey,
  effectiveTo: dateKey.optional(),
  reason: z.string().trim().max(500).optional(),
});
export type StandardCostInput = z.infer<typeof standardCostInput>;

export interface CostHistoryRow {
  unitCost: string;
  effectiveFrom: string; // YYYY-MM-DD
  effectiveTo: string | null;
}

/**
 * เลือกต้นทุนที่มีผล ณ `date` จากประวัติ (half-open [from, to))
 * คืน null ถ้าไม่มีต้นทุนครอบคลุมวันนั้น (→ SKU ไม่มีต้นทุน = incomplete)
 */
export function resolveEffectiveCost(history: CostHistoryRow[], date: string): string | null {
  for (const h of history) {
    if (h.effectiveFrom <= date && (h.effectiveTo === null || date < h.effectiveTo)) {
      return h.unitCost;
    }
  }
  return null;
}
